const CheckIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export default function QuestionCard({ question, dimensionLabel, number, value, onChange }) {
  return (
    <div className="question">
      {dimensionLabel && <div className="question-category">{dimensionLabel}</div>}
      <h2>{number != null && <span className="question-number">{number}.</span>} {question.text}</h2>
      <div className="question-options">
        {question.options.map((opt) => {
          const selected = value === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              className={`option ${selected ? 'selected' : ''}`}
              onClick={() => onChange(opt.value)}
            >
              <span className="option-label">{opt.label}</span>
              <span className="option-check"><CheckIcon /></span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
